export default __webpack_public_path__ + "static/media/JobsWorks.d379ffffa9ca1c270631daaea99d238c.webp";